import type { InputType, ModalProps } from 'config'
import { cloneDeep } from 'lodash'
import { useEffect, useState } from 'react'
import { createProduct, updateProduct } from 'services'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import type { IProduct } from './types'

const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      title: 'Title',
      inputType: 'text',
      error: '',
      required: true,
    },
    quantity: {
      title: 'Quantity',
      inputType: 'text',
      type: 'number',
      error: '',
      required: true,
    },
    link: {
      title: 'Link',
      inputType: 'text',
      error: '',
      required: true,
    },
  }
}

export const ProductDialog = (props: ModalProps & { auctionId: number; data: IProduct | null }) => {
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState<Record<string, InputType>>(defaultInputs())

  useEffect(() => {
    if (!props.data) return
    const newInputs = cloneDeep(inputs)
    Object.keys(newInputs).forEach((key) => (newInputs[key].value = (props.data as any)[key]))
    setInputs(newInputs)
  }, [])

  const onChangeInputs = (key: string, value: string) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    newInputs[key].error = ''
    setInputs(newInputs)
  }

  const onOk = async () => {
    let hasError = false
    const newStats = cloneDeep(inputs)
    const inputData: Record<string, any> = {}
    for (const key in newStats) {
      const { value } = newStats[key]
      let error = InputValidate(newStats[key])
      newStats[key].error = error
      if (error.length > 0) hasError = true

      if (value !== undefined) inputData[key] = value
    }
    if (hasError) {
      setInputs(newStats)
      return
    }

    setLoading(true)

    delete inputData.preview

    try {
      if (!props.data) {
        const newValues = await createProduct(props.auctionId, inputData)
        props.onSubmit && props.onSubmit(newValues)
      } else {
        const newValues = await updateProduct(props.auctionId, props.data.id, inputData)
        props.onSubmit && props.onSubmit(newValues)
      }
    } catch (e) {}
    setLoading(false)
  }

  return (
    <Modal
      isOpen
      title={!props.data ? 'Add New Product' : `Update Product #${props.data.id}`}
      titleOkay="Submit"
      onOk={onOk}
      onClose={() => props.onClose()}
      loading={isLoading}
    >
      <div className={`text-gray-600 text-md w-128`}>
        <div className="grid grid-cols-1 gap-4">
          {Object.keys(inputs).map((key, index) => {
            const input = inputs[key]
            return (
              <div key={index} className={`input col-span-${input.span || 1}`}>
                <RenderInput input={input} Key={key} onChange={onChangeInputs} />
              </div>
            )
          })}
        </div>
      </div>
    </Modal>
  )
}
